import { getHours, getMinutes, isSameDay } from "date-fns";

import type { DisabledTimes } from "@/ui-adapters/AntDatePicker";

export function disabledTime(enableMidnight: boolean, current: Date, min?: Date, max?: Date): DisabledTimes {
  const disabledTimes: DisabledTimes = {};

  disabledTimes.disabledHours = () => {
    const disabled = new Set<number>();

    if (min && isSameDay(current, min)) {
      const minHour = getHours(min);
      const startDisableHour = enableMidnight ? 1 : 0;
      for (let i = startDisableHour; i < minHour; i++) {
        disabled.add(i);
      }
    }

    if (max && isSameDay(current, max)) {
      const maxHour = getHours(max);
      for (let i = maxHour + 1; i < 24; i++) {
        disabled.add(i);
      }
    }

    return Array.from(disabled).sort((a, b) => a - b);
  };

  disabledTimes.disabledMinutes = () => {
    const disabled = new Set<number>();
    const currentHour = getHours(current);

    if (min && isSameDay(current, min) && currentHour === getHours(min)) {
      const minMinutes = getMinutes(min);
      for (let i = 0; i < minMinutes; i++) {
        disabled.add(i);
      }
    }

    if (max && isSameDay(current, max) && currentHour === getHours(max)) {
      const maxMinutes = getMinutes(max);
      for (let i = maxMinutes + 1; i < 60; i++) {
        disabled.add(i);
      }
    }

    return Array.from(disabled).sort((a, b) => a - b);
  };

  return disabledTimes;
}
